import { cn } from '@/lib/utils';
import { TrialContinueButton } from './trial-continue-button';
import { useTrialActivation } from '@/hooks/useTrialActivation';

interface TrialActivationButtonProps {
    onSuccess?: () => void;
    className?: string;
    title?: string;
    showDesc?: boolean;
    buttonClassName?: string;
}

export function TrialActivationButton({
    onSuccess,
    className,
    title = "Start Free Trial",
    showDesc = false,
    buttonClassName
}: TrialActivationButtonProps) {
    const { isActivating, activationError, handleStartTrial: activateTrial } = useTrialActivation();

    const handleStartTrial = async () => {
        const result = await activateTrial();
        if (result?.success && onSuccess) {
            onSuccess();
        }
    };

    return (
        <>
            <TrialContinueButton
                className={className}
                buttonClassName={cn("min-w-[200px]", buttonClassName)}
                onClick={handleStartTrial}
                title={title}
                disabled={isActivating}
                showDesc={showDesc}
            />
            {activationError && (
                <p className="mt-3 text-center text-sm text-red-500">{activationError}</p>
            )}
        </>
    );
}
